import * as Yup from 'yup';

export const ReanaliseReembolsoValidation = Yup.object({
  valor: Yup.string().required('Valor deve ser preenchido'),
  motivo: Yup.string().required('Motivo deve ser preenchido'),
});